import React, { useState } from 'react'
import { Menu } from 'antd'
import { func, string, object } from 'prop-types'
import './step.css'
import * as moment from 'moment'
import 'moment/locale/pt-br'
import JSONInput from 'react-json-editor-ajrm'
import locale from 'react-json-editor-ajrm/locale/pt'

import Editor from 'react-simple-code-editor'
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-css'
import 'prismjs/themes/prism.css' //Example style, you can use another

// Add Inline Color plugin for prism
import 'prismjs/plugins/line-numbers/prism-line-numbers'
import 'prismjs/plugins/line-numbers/prism-line-numbers.css'

// Add Inline Color plugin for prism

moment.locale('pt-br')

const Tabs = ({
	updateCkeditorCss,
	updateCkeditorStyles,
	ckeditorStyles,
	currentCss,
}) => {
	const [value, setValue] = useState('1')
	const [initalCSS, setCKEditorCss] = useState(currentCss || '')
	const [initialStyles] = useState(ckeditorStyles || '')

	const tab = (option) => {
		if (option === '1') {
			return (
				<Editor
					value={initalCSS}
					onValueChange={(code) => {
						updateCkeditorCss(code)
						setCKEditorCss(code)
					}}
					highlight={(code) => highlight(code, languages.css)}
					padding={10}
					style={{
						fontFamily: '"Roboto Mono", Monaco, monospace',
						fontSize: 11,
					}}
					preClassName="line-numbers"
				/>
			)
		} else if (option === '2') {
			return (
				<JSONInput
					id={`json`}
					placeholder={initialStyles}
					theme="light_mitsuketa_tribute"
					onChange={(e) => {
						try {
							updateCkeditorStyles(JSON.parse(e.json))
						} catch (error) {
							console.error(error)
						}
					}}
					waitAfterKeyPress={250}
					locale={locale}
					confirmGood={false}
					height="100%"
					width="100%"
				/>
			)
		} else {
			return <div>No tab</div>
		}
	}

	return (
		<div>
			<Menu
				onClick={(e) => {
					setValue(e.key)
				}}
				selectedKeys={[value]}
				mode="horizontal"
				style={{
					width: '100%',
				}}>
				<Menu.Item style={{ textAlign: 'center' }} key="1">
					CSS
				</Menu.Item>
				<Menu.Item style={{ textAlign: 'center' }} key="2">
					Estilos do Editor
				</Menu.Item>
			</Menu>

			<div
				style={{
					padding: '10px 10px 0',
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
				}}>
				{tab(value)}
			</div>
		</div>
	)
}

Tabs.propTypes = {
	updateCkeditorCss: func,
	ckeditorStyles: object,
	currentCss: string,
	updateCkeditorStyles: func,
}

export default Tabs
